<template>
  <div class="repair-page">
    <div class="repair-card">
      <div class="repair-header">
        <div class="repair-title">报修设置</div>
        <div class="repair-divider"></div>
        <div class="repair-toolbar">
          <div class="repair-actions">
            <el-button size="small" class="repair-btn-add" @click="openAddDialog"><i class="el-icon-plus"></i>添加报修设置</el-button>
            <el-button size="small" class="repair-btn-refresh" title="刷新" @click="fetchData"><i class="el-icon-refresh-right"></i></el-button>
          </div>
          <div class="repair-search-group">
            <el-input v-model="searchForm.repairTypeName" size="small" clearable placeholder="请输入类型名称" class="repair-search-input" />
            <el-select v-model="searchForm.repairSettingType" size="small" clearable placeholder="请选择报修设置类型" class="repair-search-select">
              <el-option v-for="item in repairSettingTypes" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
            </el-select>
            <el-select v-model="searchForm.publicArea" size="small" clearable placeholder="请选择区域" class="repair-search-select small">
              <el-option v-for="item in publicAreas" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
            </el-select>
            <el-select v-model="searchForm.repairWay" size="small" clearable placeholder="请选择派单方式" class="repair-search-select small">
              <el-option v-for="item in repairWays" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
            </el-select>
            <el-button size="small" class="repair-btn-search" @click="handleSearch"><i class="el-icon-search"></i>搜索</el-button>
          </div>
        </div>
      </div>

      <div class="repair-table-section">
        <el-table v-loading="loading" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" label="所在小区" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.communityName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="repairSettingTypeName" label="报修设置类型" min-width="130" show-overflow-tooltip />
          <el-table-column prop="repairTypeName" label="类型名称" min-width="120" show-overflow-tooltip />
          <el-table-column prop="repairWayName" label="派单方式" min-width="110" show-overflow-tooltip />
          <el-table-column label="区域" min-width="90" show-overflow-tooltip><template slot-scope="scope">{{ formatArea(scope.row) }}</template></el-table-column>
          <el-table-column label="业主端展示" min-width="110"><template slot-scope="scope">{{ scope.row.isShow === 'Y' ? '是' : '否' }}</template></el-table-column>
          <el-table-column label="通知方式" min-width="120" show-overflow-tooltip><template slot-scope="scope">{{ formatNotify(scope.row.notifyWay) }}</template></el-table-column>
          <el-table-column prop="returnVisitFlagName" label="是否回访" min-width="110" show-overflow-tooltip />
          <el-table-column label="办理时长" min-width="100"><template slot-scope="scope">{{ scope.row.doTime || '-' }}小时</template></el-table-column>
          <el-table-column label="超时预警" min-width="100"><template slot-scope="scope">{{ scope.row.warningTime || '-' }}分钟</template></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="170" show-overflow-tooltip />
          <el-table-column label="操作" min-width="190" fixed="right">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="openEditDialog(scope.row)">修改</a>
                <span class="link-separator"></span>
                <a class="action-link" @click="bindRepairMaster(scope.row)">绑定维修师傅</a>
                <span class="link-separator"></span>
                <a class="action-link danger" @click="openDeleteDialog(scope.row)">删除</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="repair-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination :current-page="pagination.current" :page-size="pagination.size" layout="prev, pager, next, jumper" :total="pagination.total" @current-change="handleCurrentChange" />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <add-repair-setting ref="addDialog" @success="fetchData" />
    <edit-repair-setting ref="editDialog" @success="fetchData" />
    <delete-repair-setting ref="deleteDialog" @success="fetchData" />
  </div>
</template>

<script>
import { listRepairSettings } from '@/api/work/repairSettingApi'
import AddRepairSetting from '@/components/work/AddRepairSetting'
import EditRepairSetting from '@/components/work/EditRepairSetting'
import DeleteRepairSetting from '@/components/work/DeleteRepairSetting'
import { getDict } from '@/api/community/communityApi'

export default {
  name: 'RepairSettingList',
  components: { AddRepairSetting, EditRepairSetting, DeleteRepairSetting },
  data() {
    return {
      loading: false,
      searchForm: { repairTypeName: '', repairWay: '', repairSettingType: '', publicArea: '' },
      tableData: [],
      repairWays: [],
      repairSettingTypes: [],
      publicAreas: [],
      pagination: { current: 1, size: 10, total: 0 }
    }
  },
  created() {
    this.fetchData()
    this.loadDictData()
  },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 500, height: '44px', padding: '0', border: 'none' } },
    cellStyle() { return { color: '#1D2129', height: '48px', padding: '0', border: 'none' } },
    async fetchData() {
      this.loading = true
      try {
        const res = await listRepairSettings({ page: this.pagination.current, row: this.pagination.size, ...this.searchForm })
        this.tableData = res.data || []
        this.pagination.total = Number(res.records || res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '获取报修设置列表失败')
      } finally {
        this.loading = false
      }
    },
    async loadDictData() {
      this.repairWays = await getDict('r_repair_setting', 'repair_way')
      this.repairSettingTypes = await getDict('r_repair_setting', 'repair_setting_type')
      this.publicAreas = await getDict('r_repair_setting', 'public_area')
    },
    formatArea(row) { return row.publicAreaName || (row.publicArea === 'T' ? '非房屋' : '房屋') },
    formatNotify(value) { return { SMS: '短信', WECHAT: '微信', WORK_LICENSE: '微信+员工工牌' }[value] || value || '-' },
    handleSearch() { this.pagination.current = 1; this.fetchData() },
    handleSizeChange(size) { this.pagination.size = size; this.pagination.current = 1; this.fetchData() },
    handleCurrentChange(current) { this.pagination.current = current; this.fetchData() },
    openAddDialog() { this.$refs.addDialog.open() },
    openEditDialog(row) { this.$refs.editDialog.open(row) },
    openDeleteDialog(row) { this.$refs.deleteDialog.open(row) },
    bindRepairMaster(row) {
      this.$router.push({
        path: '/views/work/repairTypeUser',
        query: {
          settingId: row.settingId,
          repairType: row.repairType,
          repairTypeName: row.repairTypeName,
          communityId: row.communityId,
          communityName: row.communityName
        }
      })
    }
  }
}
</script>

<style scoped>
.repair-page { height: 100%; padding: 0; background: #F5F8FC; box-sizing: border-box; }
.repair-card { min-height: 100%; background: #FFFFFF; border-radius: 0 0 12px 12px; display: flex; flex-direction: column; overflow: hidden; }
.repair-header { padding: 20px 24px 12px; flex-shrink: 0; }
.repair-title { font: 600 16px/22px 'PingFang SC', sans-serif; color: #1D2129; }
.repair-divider { height: 1px; background: #DCE6F5; margin: 12px 0; }
.repair-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.repair-actions, .repair-search-group, .action-links, .repair-pagination { display: flex; align-items: center; }
.repair-actions { gap: 12px; }
.repair-search-group { gap: 12px; margin-left: auto; flex-wrap: wrap; justify-content: flex-end; }
.repair-btn-add { height: 38px; padding: 0 16px; background: #0E76FF; border: none; border-radius: 10px; color: #fff; font-size: 14px; }
.repair-btn-refresh { width: 38px; height: 38px; padding: 0; border-radius: 10px; border: 1px solid #DCE6F5; color: #364153; background: #fff; }
.repair-btn-search { height: 38px; padding: 0 16px; border-radius: 10px; border: 1px solid #0E76FF; background: #fff; color: #0E76FF; }
.repair-search-input { width: 180px; }
.repair-search-select { width: 180px; }
.repair-search-select.small { width: 150px; }
.repair-search-group >>> .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; color: #1D2129; }
.repair-table-section { flex: 1; padding: 12px 24px 0; overflow: auto; }
.repair-table-section >>> .el-table { border-radius: 8px; overflow: hidden; }
.repair-table-section >>> .el-table::before { display: none; }
.repair-table-section >>> .el-table th, .repair-table-section >>> .el-table td { border: none; }
.action-links { gap: 8px; white-space: nowrap; }
.action-link { color: #0E76FF; cursor: pointer; font-size: 14px; }
.action-link.danger { color: #F53F3F; }
.link-separator { width: 1px; height: 12px; background: #DCE6F5; }
.repair-pagination { justify-content: flex-end; gap: 8px; padding: 16px 24px 24px; flex-shrink: 0; }
.pagination-total { color: #6A7282; font-size: 14px; }
.pagination-size-select { width: 96px; }
.pagination-size-select >>> .el-input__inner { height: 32px; border-radius: 8px; }
@media (max-width: 1100px) { .repair-toolbar { align-items: flex-start; flex-direction: column; } .repair-search-group { margin-left: 0; justify-content: flex-start; } }
</style>
